<template>
    <div class="Page">
        <Header Act="1"></Header>
        <div class="MaxWid">
            <div class="NoticeList">
                <div class="NoticeListTitle">公告栏</div>
                <div class="NoticeListContent">
                    <div class="NoticeItem" v-for="item in NoticeData" :key="item.id" @click="GoDetail(item)">
                        <div class="NoticeItemRight">
                            <img :src="$Global.CommImgHttp+item.img" alt="">
                        </div>
                        <div class="NoticeItemLeft">
                            <i class="el-icon-caret-right"></i>
                            <span class="NoticeTitle">{{item.title}}</span>
                        </div>
                        
                        <div class="NoticeTime">
                            {{formatTime(item.updatetime)}}
                        </div>
                    </div>
                </div>
                <div class="PageDis">
                    <el-pagination 
                        background 
                        :page-sizes="[10, 20, 50]" 
                        layout="prev,pager,next,total,sizes"  
                        @size-change="SizeChange" 
                        @current-change="PageChange" 
                        :total="total" 
                        :current-page="page" 
                        :page-size="pageSize"
                        :hide-on-single-page="false">
                    </el-pagination>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/header/head';
import Footer from '@/components/header/footer';

export default {
    components: {
        Header,
        Footer
    },
    data() {
        return {
            NoticeData: [],
            total: 0,
            page: 1,
            pageSize: 10
        }
    },
    mounted() {
        this.GetNoticeList();
    },
    methods: {
        GetNoticeList() {
            this.$post("api/index/noticeList", {
                page: this.page,
                limit: this.pageSize
            }).then(res => {
                if(res.data.code == 1) {
                    this.NoticeData = res.data.data.data;
                    this.total = res.data.data.total;
                }
            })
        },
        SizeChange(val) {
            this.pageSize = val;
            this.GetNoticeList();
        },
        PageChange(val) {
            this.page = val;
            this.GetNoticeList();
        },
        GoDetail(item) {
            // 同时保存到localStorage（向后兼容）和通过路由参数传递
            localStorage.setItem("Info", JSON.stringify(item));
            localStorage.setItem("InfoState", 5);
            this.$router.push({
                path: '/InfoDetail',
                query: {
                    id: item.id,
                    type: 5  // 5=公告栏
                }
            });
        },
        formatTime(timestamp) {
            if (!timestamp) return '';
            const date = new Date(timestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
    }
}
</script>

<style scoped>
.Page {
    background: #fff;
}

.MaxWid {
    max-width: 1180px;
    padding: 0 10px;
    margin: 0 auto;
}

.NoticeList {
    margin: 20px 0;
}

.NoticeListTitle {
    font-size: 24px;
    color: #235da7;
    font-weight: bold;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #394788;
}

.NoticeListContent {
    background: #fff;
}

.NoticeItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
}

.NoticeItem:hover {
    background: #f5f5f5;
}

.NoticeItemLeft {
    display: flex;
    align-items: center;
    flex: 1;
}

.NoticeTitle {
    margin-left: 10px;
    font-size: 16px;
    color: #333;
}

.NoticeItemRight {
    width: 50px;
    height: 50px;
    margin-left: 20px;
}

.NoticeTime {
    margin-left: 20px;
    color: #999;
    font-size: 14px;
    white-space: nowrap;
}

.NoticeItemRight img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.PageDis {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    padding: 20px 0;
}
</style> 